var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadCloud02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_90_10678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.02184 14.3546L10.2272 17.5599M10.2272 17.5599L13.4325 14.3546M10.2272 17.5599V10.3479M16.6378 14.1485C17.6166 13.3401 18.2404 12.1172 18.2404 10.7486C18.2404 8.31452 16.2672 6.3413 13.8331 6.3413C13.658 6.3413 13.4942 6.24995 13.4053 6.09909C12.3603 4.32583 10.431 3.13599 8.22383 3.13599C4.90462 3.13599 2.21387 5.82674 2.21387 9.14595C2.21387 10.8016 2.88333 12.3008 3.96633 13.3878",
    stroke: "#344054",
    strokeWidth: 1.60266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90_10678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2319,
    height: 19.2319,
    fill: "white",
    transform: "translate(0.611328 0.731934)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCloud02);
export default __webpack_public_path__ + "static/media/download-cloud-02.6e964e9e78761ca06c0acc14be33dd5e.svg";
export { ForwardRef as ReactComponent };